<template>
	<span :class="`app-icon icon-${icon} ${$attrs.class ? $attrs.class : ''}`" />
</template>

<script>
	export default {
		name: 'AppIcon',
		props: {
			icon: {
				type: String,
				default: null,
			},
		},
	};
</script>
